import {Base} from "@/api/Base"

export class AnnualLeavePlanEdit extends Base {
    path = "annualLeavePlan/edit"
}